export default "__VITE_ASSET__COt2EPu3__"